import { render, staticRenderFns } from "./SimpleLayout.vue?vue&type=template&id=7b7b904e"
import script from "./SimpleLayout.vue?vue&type=script&lang=ts"
export * from "./SimpleLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports